import React, { useEffect, useState } from 'react';
import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';
import { Card, Form, Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import MainDashboardZen from './MainDashboardZen';
import { useLocation, useParams } from "react-router-dom";
import queryString from "query-string";

const LineDashboardZen = () => {
    const { search } = useLocation();

    const searchParams = queryString.parse(search);
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    const [selectedLid, setSelectedLid] = useState("");
    const [loadLineAccess, setLoadLineAccess] = useState(null);
    const [loginError, setLoginError] = useState(false);



    const fetchLineAccess = () => {
        liracrypt
            .get("/linedashboard/access", {})
            .then(({ data }) => {

                if (data.data.length === 1) {
                    setSelectedLid(data.data[0]["_id"]);
                } else {
                    setLoadLineAccess(data.data);
                }
            })
            .catch(function (error) {
                console.log("fetchLineAccess Error****:", error);
                if (error.response !== undefined) {
                    if (error.response.status !== 401) {
                        ApiErrorComp(error.response.status);
                    } else {
                        setLoginError(true);
                    }
                }
            });
    };

    useEffect(() => {
        if(searchParams.lid){
            setSelectedLid(searchParams.lid)
        } else {
            fetchLineAccess();
        }
    }, []);


    const selectLid = ( (!selectedLid && !searchParams.lid) &&
        <div className="dash">
            <Card
                title={
                    <span style={{ fontWeight: 600 }}>Please select a line</span>
                }
                bordered={false}
                style={{
                    width: "600px",
                    margin: "10% auto",
                    backgroundColor: "#424358",
                    border: 0,
                    boxShadow: "5px 5px 10px #1f1f1f, -5px -5px 10px #2d2d2d",
                    borderRadius: "10px",
                    fontWeight: "600",
                    padding: "10px",
                }}
            >
                {loadLineAccess ? (
                    <Form.Item
                        className="selectLine"
                        rules={[{ required: true, message: "Select a line" }]}
                    >
                        <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select a line"
                            optionFilterProp="children"
                            onChange={(value) => {
                                setSelectedLid(value);
                            }}
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {loadLineAccess.map((obj) => (
                                <Select.Option value={obj._id}>{obj.lame}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                ) : (
                    <div className="Loading">
                        <Spin indicator={antIcon} />
                    </div>
                )}
            </Card>
        </div>
    )

    return (
        <div className='line-dashboard-zen'>
            {selectLid}
            {
                selectedLid && (
                    <MainDashboardZen selectedLid={selectedLid} setSelectedLid={setSelectedLid} />
                )
            }
        </div>
    )
};

export default LineDashboardZen;